import React, { useEffect, useRef } from 'react';
import _ from 'lodash';
import L from 'leaflet';
import { useMap } from 'react-leaflet';
import i18n from 'i18next';
import { useSelector, useDispatch } from 'react-redux';
import HeatmapOverlay from 'heatmap.js/plugins/leaflet-heatmap/leaflet-heatmap.js';
var t = i18n.getFixedT(null, 'traffic-statistic');
var HeatMapComponent = /*#__PURE__*/React.memo(function (props) {
  var _useSelector = useSelector(function (state) {
    return state.toJS();
  }),
      heatmapMarkers = _useSelector.trafficStatistic.heatmapMarkers;

  var dispatch = useDispatch();
  var map = useMap();
  var heatmapLayer = useRef();
  useEffect(function () {
    if (_.isEmpty(heatmapMarkers)) return;
    var option = {
      scaleRadius: false,
      radius: 15,
      // 密度半徑
      useLocalExtrema: true,
      latField: 'y',
      lngField: 'x',
      valueField: 'value',
      maxOpacity: .8
    };
    heatmapLayer.current = new HeatmapOverlay(option);
    heatmapLayer.current.addTo(map);
    var data = {
      max: 3,
      data: heatmapMarkers
    };
    heatmapLayer.current.setData(data);
  }, [JSON.stringify(heatmapMarkers)]);
  return null;
});
export default HeatMapComponent;